import React, { useState } from 'react';
// @ts-ignore
import styles from './SearchCaseContactNoResults.module.scss';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import Text from '../../../BaseModule/Components/Text';
import ContactMyDoctorModal from '../ContactMyDoctor/ContactMyDoctorModal';

const SearchCaseContactNoResults: React.FC = () => {
	const [isContactMyDoctorOpen, setIsContactMyDoctorOpen] = useState(false);

	return (
		<div className={styles.wrapper}>
			<Text
				tx='component.searchCaseContactNoResults.text'
				className={styles.text}
			/>
			<Text
				tx='component.searchCaseContactNoResults.text2'
				className={styles.text2}
			/>
			<div className={styles.buttonWrapper}>
				<LinkButton
					text='component.searchCaseContactNoResults.contactMyDoctor'
					firstUpper
					theme='purple'
					onClick={() => setIsContactMyDoctorOpen(true)}
				/>
			</div>
			{isContactMyDoctorOpen && (
				<ContactMyDoctorModal
					isOpen
					onClose={() => setIsContactMyDoctorOpen(false)}
				/>
			)}
		</div>
	);
};

export default SearchCaseContactNoResults;
